import "core-js/modules/es6.function.name";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, httpAction } from '@/api/manage'; // 表头

var columns = [{
  dataIndex: 'name',
  colName: 'name',
  title: '名称',
  align: 'center',
  sorter: true,
  scopedSlots: {
    customRender: 'name'
  }
}, {
  dataIndex: 'apiType',
  colName: 'api_type',
  title: '平台类型',
  align: 'center',
  scopedSlots: {
    customRender: 'apiType'
  }
}, {
  dataIndex: 'serial',
  colName: 'serial',
  title: '设备序列号',
  align: 'center',
  scopedSlots: {
    customRender: 'serial'
  }
}, {
  dataIndex: 'deviceType',
  colName: 'device_type',
  title: '设备类型',
  align: 'center',
  scopedSlots: {
    customRender: 'deviceType'
  }
}, {
  dataIndex: 'code',
  colName: 'code',
  title: '设备验证码',
  align: 'center',
  scopedSlots: {
    customRender: 'code'
  }
}, {
  dataIndex: 'aiDeviceCode',
  colName: 'aiDeviceCode',
  title: 'AI设备编号',
  align: 'center',
  scopedSlots: {
    customRender: 'aiDeviceCode'
  }
}, {
  dataIndex: 'channel',
  colName: 'channel',
  title: '通道号',
  align: 'center',
  scopedSlots: {
    customRender: 'channel'
  }
}, {
  dataIndex: 'insideCode',
  colName: 'insideCode',
  title: '内部编号',
  align: 'center',
  scopedSlots: {
    customRender: 'insideCode'
  }
}, {
  dataIndex: 'sort',
  colName: 'sort',
  title: '排序',
  align: 'center',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  dataIndex: 'remark',
  colName: 'remark',
  title: '备注',
  align: 'center',
  scopedSlots: {
    customRender: 'remark'
  }
}, {
  title: '操作',
  dataIndex: 'action',
  align: 'center',
  width: 120,
  scopedSlots: {
    customRender: 'action'
  }
}];
var dataSource = []; // PS相关的KEY不能为title关键字

var addData1Index = 0;
export default {
  name: 'LiveDeviceList',
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      pagePath: '/site/live/device',
      // pageTitle: '监控设备信息',
      visible: false,
      title: '',
      disableSubmit: false,
      dataSource: dataSource,
      addData1Index: addData1Index,
      columns: columns,
      editingKey: '',
      tenantId: ''
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    refresh: function refresh(record) {
      this.siteId = record.id;
      this.tenantId = record.tenantId;
      this.queryParam.siteId = this.siteId;
      this.visible = true;
      this.loadData(); // this.loading = true
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      if (this.queryParam.siteId == null) return;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.records.length; i++) {
            var param = res.result.records[i];
            param.key = param.code;
            param.editable = false;
            paramList.push(param);
          }

          _this.dataSource = paramList;
          _this.ipagination.total = res.result.total;
        }

        if (res.code === 510) {
          _this.$notification.warning({
            message: res.message
          });
        }

        _this.loading = false;
      });
    },
    handleChange: function handleChange(value, key, column) {
      var newData = _toConsumableArray(this.dataSource);

      console.log('handleChange', value, key, column); // if(key){
      //   newData.forEach(item=>{
      //     if(key === item.id){
      //       item[column] = value
      //     }
      //   })
      //   this.dataSource = newData
      // }

      var target = newData.filter(function (item) {
        return key === item.id;
      })[0];

      if (target) {
        target[column] = value;
        this.dataSource = newData;
      }
    },

    /**
     * 新增一个系统配置的相关参数
     */
    addTable: function addTable() {
      var newData = _toConsumableArray(this.dataSource);

      this.disabled = false;
      newData.push({
        key: 'A1_' + this.addData1Index,
        method: 'add',
        name: '',
        apiType: '',
        serial: '',
        deviceType: '',
        code: '',
        channel: '',
        aiDeviceCode: '',
        sort: '',
        insideCode: '',
        remark: '',
        editable: true
      });
      this.addData1Index = this.addData1Index + 1;
      this.dataSource = newData;
    },

    /**
     * table行输入保存
     * @param key
     */
    saveTable: function saveTable(target) {
      var _this2 = this;

      console.log('save', target);
      target.siteId = this.siteId;
      target.tenantId = this.tenantId;

      if (target.name != null && target.name !== '' && target.apiType != null && target.apiType !== '' && target.serial != null && target.serial !== '') {
        // target.status = target.status.toString();
        var method = 'put';

        if (target.method != null && target.method == 'add') {
          method = 'post';
        }

        httpAction(this.pagePath, target, method).then(function (res) {
          if (res.success) {
            _this2.$notification.success({
              message: res.message
            });

            target.editable = false;
            target.id = res.result.id;
          } else {
            _this2.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.$message.warning('请填写名称、平台类型、设备序列号！');
      }

      this.editingKey = '';
    },

    /**
     * table行删除
     * @param key
     */
    delTable: function delTable(index) {
      if (this.dataSource[index].id) {
        this.handleDelete(this.dataSource[index].id);
      } else {
        this.dataSource.splice(index, 1);
      }
    },

    /**
     * table行编辑
     * @param key
     */
    editTable: function editTable(record) {
      record.editable = true;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    }
  }
};